(() => {
  const STORAGE_KEY = 'mycanteenEmailOfferDismissed';
  const SUBSCRIBED_KEY = 'mycanteenEmailOfferSubscribed';
  const SHOW_DELAY = 10000;
  const SCROLL_THRESHOLD = 0.4;

  const getOffer = () => document.querySelector('[data-mc-email-offer]');

  const rememberDismissal = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, 'true');
    } catch (error) {
      // Storage can be unavailable in strict privacy modes.
    }
  };

  const dismissOffer = (offer = getOffer(), remember = true) => {
    if (!offer) return;

    offer.classList.remove('is-visible');
    offer.setAttribute('aria-hidden', 'true');
    if (remember) rememberDismissal();

    window.setTimeout(() => {
      // Only hide after the exit transition if it has not been reopened.
      if (!offer.classList.contains('is-visible')) offer.hidden = true;
    }, 300);
  };

  // Expose one tiny fallback for the Liquid buttons. This makes the X work
  // even if another theme script replaces/re-renders the popup after init.
  window.closeMyCanteenEmailOffer = () => dismissOffer();

  // Capture close actions at document level so theme click handlers cannot
  // swallow the event before the popup receives it.
  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest?.('[data-mc-email-close]');
    if (!closeButton) return;

    event.preventDefault();
    event.stopPropagation();
    dismissOffer(closeButton.closest('[data-mc-email-offer]'));
  }, true);

  const init = () => {
    const offer = getOffer();
    if (!offer) return;

    const success = offer.querySelector('[data-mc-email-success]');

    // Successful Shopify newsletter posts return to the page; acknowledge once
    // and remember that this browser has already subscribed.
    if (success) {
      try {
        localStorage.setItem(SUBSCRIBED_KEY, 'true');
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (error) {
        // Storage can be unavailable in strict privacy modes; popup still works.
      }

      offer.hidden = false;
      offer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => offer.classList.add('is-visible'));
      return;
    }

    try {
      if (localStorage.getItem(SUBSCRIBED_KEY) === 'true') return;
      if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;
    } catch (error) {
      // Continue without persistence if browser storage is unavailable.
    }

    let shown = false;
    let eligibleByTime = false;
    let eligibleByScroll = false;

    const show = () => {
      if (shown) return;
      shown = true;
      offer.hidden = false;
      offer.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => offer.classList.add('is-visible'));
      window.removeEventListener('scroll', onScroll);
    };

    const maybeShow = () => {
      if (eligibleByTime || eligibleByScroll) show();
    };

    const onScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      const progress = window.scrollY / scrollable;
      if (progress >= SCROLL_THRESHOLD) {
        eligibleByScroll = true;
        maybeShow();
      }
    };

    // If the offer is already open when a shopper adds a product, move it out
    // of the way for the current page only. Do NOT store a dismissal here; on
    // mobile, shoppers often add an item before the 10-second email timer fires.
    document.addEventListener('submit', (event) => {
      if (event.target instanceof HTMLFormElement && event.target.matches('form[data-type="add-to-cart-form"]')) {
        if (offer.classList.contains('is-visible')) dismissOffer(offer, false);
      }
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && offer.classList.contains('is-visible')) dismissOffer(offer);
    });

    window.addEventListener('scroll', onScroll, { passive: true });

    window.setTimeout(() => {
      eligibleByTime = true;
      maybeShow();
    }, SHOW_DELAY);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
